import {Component, inject} from '@angular/core';
import {FeatureFlagService, TranslateService} from '@brunata-angular/util';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {getRouteLabel, visibleChildRoutes} from '@shared/route-utils';
import {selectBuilding} from 'src/app/state/selectors';
import {BuildingStateSuccess} from 'src/app/state/reducers';
import {Store} from '@ngrx/store';
import {filter, map, Observable, switchMap} from 'rxjs';
import {AsyncPipe} from '@angular/common';

@Component({
    standalone: true,
    imports: [RouterLinkActive, RouterLink, RouterOutlet, AsyncPipe],
    template: `
        <ul class="nav nav-pills justify-content-start border-bottom">
            @for (tab of tabs$ | async; track tab) {
                <li class="nav-item">
                    <a
                        class="nav-link py-1 fst-italic"
                        routerLinkActive="active"
                        [routerLink]="tab.route">
                        {{ tab.text }}
                    </a>
                </li>
            }
        </ul>

        <router-outlet />
    `,
})
export class SubMenuComponent {
    protected readonly translate = inject(TranslateService);
    protected readonly route = inject(ActivatedRoute);
    protected readonly store = inject(Store);
    private readonly featureFlagService = inject(FeatureFlagService);

    readonly tabs$: Observable<
        {
            route: string;
            text: string;
        }[]
    > = this.store.select(selectBuilding).pipe(
        filter(
            (buildingState): buildingState is BuildingStateSuccess =>
                buildingState.status === 'success',
        ),
        switchMap(buildingState =>
            visibleChildRoutes(
                this.route.routeConfig?.children ?? [],
                buildingState.buildingDetails.buildingServices,
                this.featureFlagService,
            ),
        ),
        map(routes =>
            routes.map(route => ({
                route: route.path ?? '',
                text: getRouteLabel(route, this.translate),
            })),
        ),
    );
}
